import Add from '@mui/icons-material/Add'
import {TextButton} from '../1elements'

const AddContactButton = ({onClick}) => {
    return(
        <TextButton variant={'contained'} clickHandler={onClick}><Add/>Add This Contact</TextButton>
    )
}

export default AddContactButton
